<template>
  <div class="grid main-content">
    <div class="grid-left">
      <Section :details="qualities" />
      <Section :details="experience" />
    </div>
    <div class="grid-right">
      <PersonalDetails :details="personal" />
      <Ratings :details="skills" />
      <PersonalDetails :details="education" />
      <PersonalDetails :details="community" />
    </div>
  </div>
</template>

<script>
import Section from '@/components/resume/Section.vue';
import PersonalDetails from '@/components/resume/PersonalDetails.vue';
import Ratings from '@/components/resume/Ratings.vue';
import ResumeJSON from '../js/resume.js';

export default {
  name: 'resume',
  components: {
    Section,
    PersonalDetails,
    Ratings,
  },
  data() {
    return ResumeJSON;
  }
}
</script>

<style>

</style>
